module.exports = __webpack_public_path__ + "static/img/icon_Scan@2x.3549ecaa.png";